// Google Analytics 4 Tracking Hook
// Tracks page views automatically on route changes
// Only tracks if user has given consent (GDPR compliant)

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasAnalyticsConsent } from '@/components/CookieConsent';

const GA_TRACKING_ID = 'G-2N2WYBJF4J';

// Send page view to GA4 (only if consent given)
export const pageview = (url) => {
  if (hasAnalyticsConsent() && typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
      anonymize_ip: true,
    });
  }
};

// Send custom event to GA4 (only if consent given)
export const event = ({ action, category, label, value }) => {
  if (hasAnalyticsConsent() && typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Hook to track page views on route change
export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if user has given consent
    if (hasAnalyticsConsent()) {
      pageview(location.pathname + location.search);
    }
  }, [location]);
};

export default useGoogleAnalytics;
